import { t } from 'i18next';
import { ArrowLeft } from '@peacecover/icon';
import { useHandleHistoryBack } from '@pocapan/shared/utils/useHandleHistoryBack';
import { useSelectedTradingCardsStore } from '../store/useSelectedTradingCardsStore';

interface MyTradingPhotoCardsHeaderProps {
  setIsPopUpOpen: (isPopUpOpen: boolean) => void;
}

const MyTradingPhotoCardsHeader = ({ setIsPopUpOpen }: MyTradingPhotoCardsHeaderProps) => {
  const handleHistoryBack = useHandleHistoryBack();
  const selectedPhotoCards = useSelectedTradingCardsStore((state) => state.selectedPhotoCards);

  const handleHistoryBackWithModal = () => {
    if (selectedPhotoCards.length > 0) {
      setIsPopUpOpen(true);
    } else {
      handleHistoryBack();
    }
  };
  return (
    <header className="fixed top-0 left-0 right-0 flex items-center px-[16px] py-[8px] bg-pure-white dark:bg-background-dark z-10 pt-[calc(env(safe-area-inset-top)+8px)]">
      <ArrowLeft className="fill-text-main-lv1 my-[2px]" onClick={handleHistoryBackWithModal} />
      <h1 className="h-[20px] flex items-center absolute left-1/2 transform -translate-x-1/2 text-[17px] font-bold text-text-main-lv1 my-[4px] leading-none text-center">
        {t('NewTradingPhotoCards.title')}
      </h1>
    </header>
  );
};

export default MyTradingPhotoCardsHeader;
